document.addEventListener('DOMContentLoaded', function() {
  var fullbannerElements = document.querySelectorAll('[data-fullbanner]');
  
  fullbannerElements.forEach(function(fullbannerElement) {
    const initSwiper = () => {
      new Swiper(fullbannerElement, {
        slidesPerView: 1,
        spaceBetween: 10,
        watchOverflow: true,
        speed: 600,
        effect: 'slide',
        navigation: {
          nextEl: fullbannerElement.querySelector('.swiper-button-next'),
          prevEl: fullbannerElement.querySelector('.swiper-button-prev')
        },
        autoplay: {
          delay: 10000,
          disableOnInteraction: false
        },
        pagination: {
          el: fullbannerElement.querySelector('.swiper-pagination'),
          clickable: true
        }
      });
    };

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(initSwiper);
    } else {
      setTimeout(initSwiper, 100);
    }
  });
});
